import React from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";

const NotFound = ({ markets = [] }) => (
  <main className="rt-main">
    <Seo title="Page not found | Ratan Market" description="This page could not be found." path="/404" noIndex />
    <section className="rt-phead">
      <div className="rt-wrap">
        <span className="rt-eyebrow rt-eyebrow--dark">404</span>
        <h1>Page not found</h1>
        <p>The page you are looking for does not exist. Try one of these instead.</p>
      </div>
    </section>
    <section className="rt-wrap rt-section">
      <div className="rt-pills">
        <Link to="/" className="is-accent">
          Home
        </Link>
        <Link to="/charts" className="is-accent">
          All Charts
        </Link>
        {markets.map((m) => (
          <Link key={m.slug} to={`/jodi/${m.slug}`}>
            {m.name}
          </Link>
        ))}
      </div>
    </section>
  </main>
);

export default NotFound;
